import { EditIcon, EyeIcon, QuestionMarkCircleIcon, TrashIcon } from "assets";
import { Card, CustomTooltip, FullScreenModal, SmallScreenModel } from "components";
import React, { useState } from "react";
import MembershipDurationByPackageId from "modules/membership_plan/commercial_membership_plan/membership_duration/MembershipDurationByPackageId";
import { RoleProps } from "../store/actionType";
import HandleDeleteRole from "./HandleDeleteRole";
import HandleUpdateRole from "./HandleUpdateRole";
import { useUser } from "utils/helpers/UserContext";
import { Authorities } from "props/authoritries";
import { SuperAdminStatusEnum } from '../../../../props/enum';

const ActionButton: React.FC<{ items: RoleProps }> = ({ items }) => {
  const [isEditModel, setEditModel] = useState(false);
  const [isDeleteModel, setDeleteModel] = useState(false);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_CMS_ROLE));
  if (isPermitted)
  return (
    <>
      <div className="flex flex-row gap-2 justify-center">
        <CustomTooltip title="Edit" placement="bottom">
          <button className="hover:text-primary-500" onClick={() => setEditModel(true)}>
            <EditIcon />
          </button>
        </CustomTooltip>
        <CustomTooltip title="Delete" placement="bottom">
          <button className="hover:text-red-500" onClick={() => setDeleteModel(true)}>
            <TrashIcon className="" />
          </button>
        </CustomTooltip>
      </div>
      <SmallScreenModel setShowModal={setEditModel} showModal={isEditModel}>
        <HandleUpdateRole roleData={items} closeModal={setEditModel} />
      </SmallScreenModel>
      <SmallScreenModel setShowModal={setDeleteModel} showModal={isDeleteModel}>
       <HandleDeleteRole  roleData={items} closeModal={setDeleteModel} />
      </SmallScreenModel>
    </>
  );
   return <></>;
};

export default ActionButton;
